export default "__VITE_ASSET__DPHgUu_c__"